module.exports = require("./ru-KZ.d.ts");